import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef } from 'vue';

import { TextWithHighlight } from '@/data/datatypes/TextWithHighlight';

interface Props {
  text: string;
  highlightRegex?: RegExp;
  textWithHighlights?: TextWithHighlight[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TextWithHighlightedTerm',
  props: {
    text: null,
    highlightRegex: null,
    textWithHighlights: null
  },
  setup(__props: any) {

const props = __props as {
  text: string;
  highlightRegex?: RegExp;
  textWithHighlights?: TextWithHighlight[];
}



const splitText: ComputedRef<string[]> = computed(() => {
  if (props.textWithHighlights) {
    const result: string[] = [];
    for (const textWithHighlight of props.textWithHighlights) {
      if (textWithHighlight.pre) {
        result.push(textWithHighlight.pre);
      }
      if (textWithHighlight.highlight) {
        result.push(textWithHighlight.highlight);
      }
      if (textWithHighlight.post) {
        result.push(textWithHighlight.post);
      }
    }
    return result;
  } else if (props.text && props.highlightRegex) {
    const result: string[] = [];
    let remainder = props.text;
    while (remainder.length) {
      const match = props.highlightRegex.exec(remainder);
      if (!match) {
        result.push(remainder);
        remainder = '';
      } else {
        result.push(remainder.substr(0, match.index));
        result.push(match[0]);
        remainder = remainder.substr(match.index + match[0].length);
      }
    }
    return result;
  } else {
    return [props.text];
  }
});

function isHighlightTerm(text: string | undefined): boolean {
  if (text) {
    if (props.textWithHighlights) {
      for (const textWithHighlight of props.textWithHighlights) {
        if (textWithHighlight.highlight === text) {
          return true;
        }
      }
    } else if (props.highlightRegex) {
      return !!props.highlightRegex?.test(text);
    }
  }
  return false;
}

return { __sfc: true,props, splitText, isHighlightTerm }
}

})